<div class="date-range-picker" (clickOutside)="onClickedOutside($event)" (exclude)="'.date-range-selection'">
  <achoo-datepicker-range #dateRangePicker
                          [minDate]="minDate"
                          [maxDate]="maxDate"
                          [defaultFromDate]="defaultFromDate"
                          [defaultToDate]="defaultToDate"
                          (selectionDateRangeEvent)="onSelectDateRange($event)">
  </achoo-datepicker-range>
  <div class="action-buttons-group">
    <div class="action-buttons-seperator"></div>
    <div class="d-flex flex-row button-group">
      <button class="button gray" (click)="resetDateRangeSelection()">{{'common.btn.reset' | translate}}</button>
      <div class="d-flex flex-auto"></div>
      <button class="button blue" (click)="applyDateRangeSelection()">{{'common.btn.apply_dates' | translate}}</button>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/measure/measure-date-range-selection/measure-date-range-selection.component.html